import { AlertTriangle } from "lucide-react";
import { SOURCES } from "@/data/sources";

export function MethadonWarnings() {
  return (
    <div
      role="alert"
      className="glass-card"
      style={{
        padding: "clamp(0.85rem, 3vw, 1.25rem) clamp(0.85rem, 3vw, 1.5rem)",
        marginBottom: "1.5rem",
        border: "1px solid rgba(248,113,113,0.5)",
        background:
          "linear-gradient(135deg, rgba(248,113,113,0.08), rgba(251,146,60,0.05))",
        display: "flex",
        gap: "clamp(0.6rem, 2vw, 1rem)",
        alignItems: "flex-start",
      }}
    >
      <AlertTriangle
        size={22}
        style={{ color: "#f87171", flexShrink: 0, marginTop: 2 }}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        <strong style={{ color: "#fca5a5", fontSize: "0.95rem" }}>
          Methadon, spezielle Warnhinweise
        </strong>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Nicht-lineare Umrechnung:</strong>{" "}
          Der Morphin-Umrechnungsfaktor ist nicht linear und steigt mit der Tagesdosis
          (grob 4:1 bei niedrigen bis 12:1 bei hohen Morphindosen). Feste mg-Werte täuschen
          Präzision vor und führen zu Überdosierungen. Deshalb steht in der Tabelle bewusst
          "variabel" statt einer Zahl.
        </p>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Kumulation und verzögerter Tod:</strong>{" "}
          Die spürbare Wirkung hält oft nur 4-8 h, die Halbwertszeit aber ~24 h
          (Spanne 15-60 h). Nachlegen baut den Spiegel weiter auf, obwohl die Wirkung
          schon verpufft scheint. Der Tod tritt oft verzögert ein, teils 24-48 h nach
          der letzten Einnahme.
        </p>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>QT-Verlängerung/Torsades:</strong>{" "}
          Methadon kann das QT-Intervall verlängern und Torsades de pointes auslösen.
          Fälle wurden häufiger bei hohen Dosen beobachtet, aber auch bei üblichen
          Substitutionsdosen. EKG-Kontrolle relevant, besonders bei Behandlungsbeginn
          und Dosissteigerung bei Risikofaktoren wie Reizleitungsstörungen,
          Kalium- oder Magnesiummangel sowie Kombination mit anderen
          QT-verlängernden Substanzen.{" "}
          <a
            href={SOURCES["dailymed-methadose-2026"].url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--accent)", textDecoration: "underline" }}
          >
            Quelle: Methadose, US-Fachinformation, hervorgehobener Warnhinweis und Abschnitt 5.3
          </a>
          {" "}(Stand 04/2026; geprüft am 07.10.2026).
        </p>
      </div>
    </div>
  );
}
